import { API } from "aws-amplify";
import { OffLineAPI } from '../offline-auth/api';

var _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;



export function getLicense(id) {
    const body = { userId: id }
    return _API.post("users", `/getLicenses`, { body });
}